export default __webpack_public_path__ + "c2034a4b47f47e373883626ddaffb1b1.png";